

export enum AppTableNamesEnum {
    M_LINE = 'm_line',
    M_OPERATOR = 'm_operator',
    M_OPERATION = 'm_operation',
    M_WORKSTATION = 'm_workstation',
    M_STYLE = 'm_style',
    M_SHIFT = 'm_shift',
    M_REASON = 'm_reason',
    M_STYLE_OPERATION = 'm_style_operation',
    T_LINE_DAY_PLAN = 't_line_day_plan',
    T_LINE_ACTUAL_DAY_TRACK = 't_line_actual_day_track',
    T_LINE_EFF_DAY_TRACK = 't_line_efficiency_day_track',
    T_OPERATOR_EFF_DAY_TRACK = 't_operator_efficiency_day_track',
    T_LINE_DOWN_TIME = 't_line_down_time'
}
